import React from 'react';
import './style.css';



const PageArpejos= () => {
  

  return (
    <>
      <div id="container-page-arpejos">
        <h1>PAGINA DE ARPEJOS EM CONSTRUÇÃO</h1>

       
      </div>
    </>
  )
}

export default PageArpejos